export default "/fonts/RV-Harmonia-Light.woff?ebdf726307773f8ba29ae401d18f243c";